import Quill from 'quill';

export const LINE_HEIGHTS = ['1.0', '1.2', '1.5', '1.6', '1.8', '2.0', '2.4', '2.8', '3.0', '4.0', '5.0'];

export const FONT_FAMILIES = [
  'Roboto', 'Roboto Condensed', 'Times New Roman', 'Calibri', 'Calibri Light',
  'Cambria', 'Georgia', 'Verdana', 'Sans-Serif',
];

export const FONT_SIZES = [
  '10px', '11px', '12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px',
  '28px', '30px', '32px', '34px', '36px', '38px', '40px', '42px', '44px', '46px',
  '48px', '50px', '52px', '54px', '56px', '58px', '60px', '62px', '64px', '72px', '96px',
];

// Runs once at import. The previous code re-registered all of this on every
// render of every shape, from inside the component body.
const Parchment = Quill.import('parchment');
const lineHeightConfig = { scope: Parchment.Scope.INLINE, whitelist: LINE_HEIGHTS };
Parchment.register(new Parchment.Attributor.Class('lineheight', 'ql-line-height', lineHeightConfig));
Parchment.register(new Parchment.Attributor.Style('lineheight', 'line-height', lineHeightConfig));

const fonts = Quill.import('attributors/style/font');
fonts.whitelist = FONT_FAMILIES;
Quill.register(fonts, true);

const Size = Quill.import('attributors/style/size');
Size.whitelist = FONT_SIZES;
Quill.register(Size, true);

export const TOOLBAR_CONFIG = [
  ['bold', 'italic', 'underline', 'strike'],
  ['link'],
  [{ lineheight: LINE_HEIGHTS }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ script: 'sub' }, { script: 'super' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ direction: 'rtl' }],
  [{ size: FONT_SIZES }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }],
  [{ background: [] }],
  [{ font: FONT_FAMILIES }],
  [{ align: [] }],
  ['clean'],
];
